<script>
import utils from '../../utils';
export default {
    props: {
        hover: Object,
        option: {
            type: Object,
            default() {
                return {};
            }
        },
        columns: {
            type: Array,
            required: true
        },
        rows: {
            type: Array,
            required: true
        },
        formatter: {
            type: Object
        },
        labels: Object,
        selectRowIds: {
            type: Array,
            default() {
                return [];
            }
        },
        focusRowId: String,
        groupKey: String,
        sortColumn: Object, // {id: '', order: 'ascending'}
        //only for table
        caption: {
            type: String
        },
        // only for mbg,
        hoverRow: Object,
        frozenGroupHeader: {
            type: Boolean,
            default: false
        },
        scrollLeft: {
            type: Number
        },
        scrollTop: {
            type: Number
        },
        columnWidth: {
            type: Object
        }
    },
    data() {
        return {
            selectedRows: {},
            focusRow: null
        };
    },
    computed: {
        computedHover() {
            const obj = utils.extend(
                {},
                {
                    width: 200,
                    title: 'Action',
                    menu: []
                },
                this.hover
            );
            if (obj.removable) {
                const hoverList = [
                    {
                        id: 'removable',
                        name: 'Remove From List',
                        text: 'Remove From List',
                        click: true
                    },
                    {
                        id: 'view',
                        name: 'View',
                        text: 'View',
                        children: obj.menu
                    }
                ];
                obj.menu = hoverList;
            }
            return obj;
        }
    },
    methods: {
        getId(row, fields) {
            const ids = [];
            fields.forEach(f => {
                if (f && row[f]) {
                    ids.push(row[f]);
                }
            });
            return ids.join();
        },
        same(rows, oldRows = [], fields = ['id']) {
            if (
                rows.length === 0 ||
                oldRows.length === 0 ||
                rows.length !== oldRows.length
            ) {
                return false;
            }
            const rowIds = rows.map(row => this.getId(row, fields));
            const oldRowIds = oldRows.map(row => this.getId(row, fields));
            // compare the sort and id are same
            return rowIds.join(',') === oldRowIds.join(',');
        },
        getFlashClass(column, newValue, oldValue) {
            let className = '';
            if (column.flash === 'color' && oldValue) {
                className =
                    newValue > oldValue
                        ? this.namespace('__cell--flash-positive')
                        : this.namespace('__cell--flash-negative');
            } else if (oldValue !== newValue && oldValue !== undefined) {
                className = this.namespace('__cell--flash');
            }
            return className;
        }
    }
};
</script>
